import { baseApi } from '@Services/api';
import { RequestTypes } from '@Constants/api';

const AutomationBuilderV0API = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        generateShortURL: builder.mutation({
            query: (payload) => ({
                url: '/v0/create_short_link',
                method: RequestTypes.POST,
                body: payload
            })
        })
    })
});

export const { useGenerateShortURLMutation } = AutomationBuilderV0API;
